import Layout from '../../internal/Layout.vue'
import ManagePage from './manage.vue'
import ConsumptionPage from './Consumption.vue'
import TesteBi1 from './teste-bi-1.vue'
import TesteBi2 from './teste-bi-2.vue'

const ConsumptionRoutes = {
  component: Layout,
  children: [
    {
      name: 'teste-bi-1',
      path: '/teste-bi-1',
      component: TesteBi1,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
        requiresWorkshopInstitution: true,
      },
    },
    {
      name: 'teste-bi-2',
      path: '/teste-bi-2',
      component: TesteBi2,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
        requiresWorkshopInstitution: true,
      },
    },
    {
      name: 'Comsumption',
      path: '/',
      component: ConsumptionPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
        requiresWorkshopInstitution: true,
      },
    },
    {
      name: 'manage',
      path: 'manage',
      component: ManagePage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
        requiresWorkshopInstitution: true,
      },
    },
  ],
}

export default ConsumptionRoutes
